<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [title]="'Add Property'"
    [class]="extraClass"
    [canGoBack]="flowType === 'rental'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
      @if (!windowService?.isDesktopRes && customFlowName) {
        <tidy-alert style="padding: 15px 15px 15px 5px">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col size="3" class="vertical-align-center">
                  <div style="margin:auto">
                    <tidy-image
                      [src]="customFlowSmallImage"
                      style="width: 50px" />
                  </div>
                </ion-col>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [body]="customFlowName" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'offers a'" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="customFlowDiscount" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="'% discount on all cleanings.'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-alert>
            }
            @if (customFlowName) {
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'Already have an account?'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'Log In'"
                    class="link"
                    (action)="goToLoginPage()" />
                </tidy-row>
                <tidy-row [align]="'center'">
                  <tidy-text
                    [helper]="'or'"
                    class="divider" />
                </tidy-row>
              }
              @if (creditBalance > 0) {
                <tidy-row [align]="'center'">
                  <tidy-text
                    [body]="'You have'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'<b>' + (creditBalance | tcurrency) + '</b>'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'in credit'" /><span>&nbsp;</span>
                        @if (employerName && employerName !== 'undefined') {
                          <tidy-text
                            [body]="'from'" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="employerName"
                              [translate]="false" /><span>&nbsp;</span>
                            }
                            <tidy-text
                              [body]="'. Add a property to use your credit to pay a pro or book a job.'" />
                          </tidy-row>
                        }
                        @if (!cameFromRentalOnboardingViewApp && (flowType === 'rental' || flowType == OnboardingFlow.NORMAL || flowType == OnboardingFlow.PRIVATE) && creditBalance == 0) {
                          <tidy-row [align]="'center'">
                            <tidy-text
                              [body]="'Enter the address for instant pricing & availability.'" />
                          </tidy-row>
                        }
                        @if (!cameFromRentalOnboardingViewApp && flowType !== 'rental' && flowType !== OnboardingFlow.NORMAL && flowType !== OnboardingFlow.PRIVATE && creditBalance == 0) {
                          <tidy-row [align]="'center'">
                            <tidy-text
                              [body]="'All TIDY features require a property. Add your first one today.'" />
                          </tidy-row>
                        }
                        @if (cameFromRentalOnboardingViewApp) {
                          <tidy-row [align]="'center'">
                            <tidy-text
                              [body]="'All TIDY features require a property. Please add a property to view the app.'" />
                          </tidy-row>
                        }
                        @if (customFlowName) {
                          <tidy-row [align]="'center'">
                            <tidy-text
                              [body]="'Enter the address for instant pricing & availability for cleanings in your area.'" />
                          </tidy-row>
                        }
                        @if (flowType == OnboardingFlow.RENTAL) {
                          <tidy-card style="padding: 15px 15px 15px 5px">
                            <tidy-card-button (action)="goToAddDirectIntegration()">
                              <tidy-grid>
                                <tidy-row>
                                  <ion-row>
                                    <ion-col size="2" class="vertical-align-center">
                                      <div style="margin:auto">
                                        <tidy-image
                                          [src]="'assets/img/integrate.svg'"
                                          style="width:40px" />
                                      </div>
                                    </ion-col>
                                    <ion-col>
                                      <tidy-row>
                                        <tidy-text
                                          [header]="'Import All Properties'" />
                                      </tidy-row>
                                      <tidy-row>
                                        <tidy-text
                                          [body]="'If you use a PMS system you can integrate to import all properties.'" />
                                      </tidy-row>
                                    </ion-col>
                                  </ion-row>
                                </tidy-row>
                              </tidy-grid>
                            </tidy-card-button>
                            <tidy-card-button (action)="goToImportCSV()">
                              <tidy-grid>
                                <tidy-row>
                                  <ion-row>
                                    <ion-col size="2" class="vertical-align-center">
                                      <div style="margin:auto">
                                        <tidy-image
                                          [src]="'assets/img/csv.svg'"
                                          style="width:30px" />
                                      </div>
                                    </ion-col>
                                    <ion-col>
                                      <tidy-row>
                                        <tidy-text
                                          [header]="'Import CSV'" />
                                      </tidy-row>
                                      <tidy-row>
                                        <tidy-text
                                          [body]="'Import all properties by importing a CSV.'" />
                                      </tidy-row>
                                    </ion-col>
                                  </ion-row>
                                </tidy-row>
                              </tidy-grid>
                            </tidy-card-button>
                          </tidy-card>
                          <tidy-row class="extra-bottom-padding">
                            <tidy-text
                              [helper]="'or'"
                              class="divider" />
                          </tidy-row>
                        }
                        <tidy-card>
                          <form [formGroup]="form" novalidate action="#">
                            @if (flowType == OnboardingFlow.RENTAL) {
                              <tidy-row class="vertical-align-center extra-bottom-padding">
                                <tidy-image
                                  [src]="'assets/img/home.svg'"
                                  class="title-size" />
                                <tidy-text
                                  [header]="'Add One Property'" />
                              </tidy-row>
                            }
                            @if (flowType == OnboardingFlow.RENTAL || customFlowName) {
                              <tidy-row class="field-top-padding">
                                <tidy-input-international-phone
                                  formControlName="phone"
                                  [label]="'Phone'"
                                  [form]="form.controls.phone"
                                  [inputMode]="'numeric'"
                                  [submitted]="submitted"
                                  [errorMessage]="'Please enter a valid phone.'"
                                  [icon]="'assets/svg/phone-portrait.svg'"
                                  [initialMask]="{ mask: '[00000000000000000000000]' }"
                                  (countryCodeChange)="onCountryCodeChange($event)" />
                              </tidy-row>
                            }
                            <tidy-row [ngClass]="flowType == OnboardingFlow.RENTAL ? '' : 'field-top-padding'">
                              <tidy-select
                                [icon]="'assets/svg/location.svg'"
                                [label]="'Country'"
                                [items]="countryList"
                                [form]="form.get('countryCode')"
                                formControlName="countryCode"
                                (optionChange)="changeCountrySelected($event)" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-auto-complete
                                label="Address"
                                formControlName="address"
                                [options]="autocompleteAddress"
                                [icon]="'assets/svg/home.svg'"
                                [form]="form.controls.address"
                                [errorMessage]="'Please enter a valid address'"
                                [submitted]="submitted"
                                (keyup)="updateSearch()"
                                (action)="chooseItem($event)" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-input
                                formControlName="address2"
                                [form]="form.controls.address2"
                                label="Unit / Apartment"
                                [errorMessage]="'Please enter a valid unit'"
                                [submitted]="submitted"
                                [icon]="'assets/img/door.svg'" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-input
                                formControlName="zipcode"
                                [customMask]="zipCodeMask"
                                [form]="form.controls.zipcode"
                                [errorMessage]="'Please enter a valid zipcode'"
                                [submitted]="submitted"
                                [inputMode]="'numeric'"
                                label="Postal Code"
                                [icon]="'assets/img/mailbox.svg'" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-input
                                formControlName="addressNickname"
                                [form]="form.controls.addressNickname"
                                [label]="'Property Nickname (optional)'"
                                [icon]="'assets/svg/information-circle.svg'" />
                            </tidy-row>
                          </form>
                        </tidy-card>
                        @if (radioButtonAddress.length > 0 && submitted && (typedOnAddress || !didChooseAddress)) {
                          <tidy-card>
                            <form [formGroup]="form" novalidate action="#">
                              <tidy-row>
                                <tidy-text
                                  [header]="'Please confirm your address:'" />
                              </tidy-row>
                              <tidy-row>
                                <tidy-radio-button
                                  [helper]="'If you do not see your address please retype it above'"
                                  [items]="radioButtonAddress"
                                  (optionChange)="chooseItem($event); setAddressFormControl($event)" />
                              </tidy-row>
                            </form>
                          </tidy-card>
                        }
                        <tidy-error-message
                          [text]="errorMessage" />
                        <tidy-button
                          [text]="'Add Property'"
                          class="primary"
                          [action]="boundAddAddress" />
                      }
                    </tidy-wrapper>
                  </ng-template>

                  <ng-template #rightColumn>
                    @if (customFlowName) {
                      <tidy-wrapper>
                        <tidy-row>
                          <tidy-image
                            style="margin: auto; width: 100%"
                            [src]="customFlowImage" />
                        </tidy-row>
                        <tidy-row [align]="'center'">
                          <tidy-text
                            [body]="customFlowName" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="'offers a'" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="customFlowDiscount" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="'% discount on all cleanings.'" />
                              </tidy-row>
                            </tidy-wrapper>
                          }
                        </ng-template>

                        <app-scroll-wrapper [templateRightColumn]="rightColumn" [templateContent]="content" />
